import { STATES } from 'common/domain/states';
import { LOANS } from 'loans.module/common/domain/constants.loans.js';

class LoansNeedALoanService {

  constructor($state, LoansOperationsService, loansStaticService, $log) {
    'ngInject';
    this.state = $state;
    this.loansOperationsService = LoansOperationsService;
    this.loansStaticService = loansStaticService;
    this.log = $log;
    this.isDataSimulationSaved = false;
  }

  onOpenDetail(dataLoan) {
    this.state.go(STATES.LOANS.DETAIL, {
      loanId: dataLoan.loanId,
      allowGoBack: dataLoan.allowGoBack,
      from: STATES.LOANS.NEED_A_LOAN,
      snapshot: this.getSnapshotDetail(dataLoan),
    });
  }

  onOpenDetailCatalog(dataLoan) {
    const snapshotTemp = this.getSnapshotDetail(dataLoan);
    snapshotTemp.step = 'resume';

    this.state.go(STATES.LOANS.DETAIL, {
      loanId: dataLoan.loanId,
      allowGoBack: dataLoan.allowGoBack,
      from: STATES.LOANS.SIGN_UP,
      snapshot: snapshotTemp,
    });
  }

  getSnapshotDetail(dataLoan) {
    return {
      loanSimulation: dataLoan.loanSimulationRequest,
      simulation: dataLoan.simulation,
      familySelected: dataLoan.familySelected,
      optionFamilySelected: dataLoan.optionFamilySelected,
      families: dataLoan.families,
      codeOptionSelected: dataLoan.codeOptionSelected,
      loan: dataLoan.loan,
    };
  }

  onSelectLoan($event, isSignUp) {
    const loanId = $event.loanId;
    const creditworthiness = $event.creditworthiness || this.creditworthiness;
    const creditworthinessOfLoan = creditworthiness[loanId];
    const hireDate = creditworthiness.hireDate;

    try {
      this.loansOperationsService.canSignUp(loanId, creditworthinessOfLoan, hireDate);
    } catch (reason) {
      return reason.message;
    }

    if ($event.simulation) {
      this.simulation = $event.simulation;
    }

    this.loan = this.getLoan(loanId);
    this.loanSimulation = $event.loanSimulation;
    this.housingLoan = this.isHousingLoan(this.loan.id);
    this.housingChange = creditworthiness.housingWitness;
    this.isVariousCredit = this.loan.id === LOANS.ID.VARIOUS_CREDIT;

    if (!isSignUp) {
      const from = STATES.LOANS.NEED_A_LOAN;
      const snapshot = this.getSnapshotSelect();
      snapshot.dataToGoBack = $event.dataToGoBack;
      this.state.go(STATES.LOANS.SIGN_UP, { from, loanId, snapshot });
    }
  }

  getLoan(loanId) {
    return this.loansStaticService.get(loanId);
  }

  isHousingLoan(loanId) {
    return loanId === LOANS.ID.SOCIAL_HOUSING_LOAN || loanId === LOANS.ID.AGREEMENT_HOUSING_LOAN;
  }

  getSnapshotSelect() {
    this.simulation = this._makeSimulation();

    return {
      loanPurposes: this.loanSimulationRequest,
      simulation: this.simulation,
      step: 'form',
      loan: this.loan,
      backSimulation: this.loanSimulation,
      isVariousCredit: this.isVariousCredit,
      housingChange: this.housingChange,
      housingLoan: this.housingLoan,
      from: STATES.LOANS.NEED_A_LOAN,
    };
  }

  _makeSimulation() {
    return {
      amountSimulation: this.simulation,
      loanPurpose: {
        option: this.loanSimulation.loanPurposeDescription,
        value: this.loanSimulation.loanPurposeId,
      },
    };
  }

  setDataSimulation(dataSimulation) {

    if (!dataSimulation) {
      return;
    }

    this.loanSimulation = dataSimulation.loanSimulation;
    this.loanSimulationRequest = dataSimulation.loanSimulationRequest;
    this.simulation = dataSimulation.simulation;
    this.familySelected = dataSimulation.familySelected;
    this.optionFamilySelected = dataSimulation.optionFamilySelected;
    this.families = dataSimulation.families;
    this.codeOptionSelected = dataSimulation.codeOptionSelected;
    this.optionsFamiliesToSelect = dataSimulation.optionsFamiliesToSelect;
    this.creditworthiness = dataSimulation.creditworthiness;
    this.isDataSimulationSaved = true;

  }

  getDataSimulation() {
    if (this.isDataSimulationSaved || this.loanSimulationRequest !== undefined) {
      if (this.simulation.amountSimulation) {
        this.simulation = this.simulation.amountSimulation;
      }

      return {
        loanSimulation: this.loanSimulation,
        loanSimulationRequest: this.loanSimulationRequest,
        simulation: this.simulation,
        familySelected: this.familySelected,
        optionFamilySelected: this.optionFamilySelected,
        families: this.families,
        codeOptionSelected: this.codeOptionSelected,
        optionsFamiliesToSelect: this.optionsFamiliesToSelect,
        creditworthiness: this.creditworthiness
      };
    }
  }

  clearAllDataSimulation() {
    this.isDataSimulationSaved = false;
    this.selectedOptionFamily = false;
    this.itemSelected = undefined;
    this.loanSimulationRequest = undefined;
    this.codeOptionSelected = null;
    this.codeLoanSimulation = undefined;
    this.simulation = {};
  }
}

export default LoansNeedALoanService;



// WEBPACK FOOTER //
// ./client/app/loans.module/common/services/loans.needALoan.service.js